

$('document').ready(function(){

$('.slide_list').slick({
  dots: true,
  infinite: true,
  arrows:false,
  speed: 3000,
  slidesToShow: 1,
});

  $('.reviewBox').slick({
  vertical: true,
  infinite: false,
  verticalSwiping: true,
  slidesToShow: 2,
  slidesToScroll: 1,
          responsive: [
        {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 



  $('.marquee').marquee({
    direction: 'left',
    duration: 20000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true,
  });


$('.featured_collection_sc .product-grid').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
        {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



  
  
});







